import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class LiquidacionCapturaMovimientosObraService {
  private service_url: string;
  public modulo_url: string;
  constructor( private http: Http,
    private constantsServices: ConstantsService,
    private validatorService: ValidatorService,
    private errorService: ErrorsService,
    private authService: AutenticacionService) {
      this.modulo_url = '/liquidacion/captura/movimientos';
      this.service_url = this.constantsServices.apiURL + this.modulo_url;
  }

  public getDefaultSchedule(date) {
    return {
      'idLiquidacion_Movimientos': '',
      'idCuentas': '',
      'idConceptos': '',
      'idProveedores': '',
      'folio': '',
      'fechaMovimiento': date,
      'importe': '',
      'descripcion': '',
      'numero': '',
      'presupuesto': '',
      'tipoMovimiento': 1,
      'cfdi': '',
      'enviadoCfdi': '',
      'chequeCancelado': false,
      'chequeConciliado': false,
      'chequeTransferencia': false,
      'cuentas': {},
      'cuentas_mixtas': {},
      'conceptos': {
        'traspaso': 0
      },
      'proveedores': {}
    };
  }

  public createMovimientosObra(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public updateMovimientosObra(data, id) {
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  public searchMovimientosObra(text, page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&search=' + text + '&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true&search=' + text, this.authService.getAuthHeaders());
  }

  public searchMovimientosObraByLiquidacion(text, idLiquidacion, page = null) {

    if (page) {
      return this.http.get(this.service_url + '?paginate=true&search=' + text + '&page=' + page + '&idLiquidacion=' + idLiquidacion, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true&search=' + text + '&idLiquidacion=' + idLiquidacion, this.authService.getAuthHeaders());
  }

  public getTotales(idLiquidacion) {
    return this.http.get(this.service_url + '/totales?idLiquidacion=' + idLiquidacion, this.authService.getAuthHeaders());
  }


  public getMovimientosObra(page = null) {

    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  public deleteMovimientoObra(folio) {
    return this.http.delete(this.service_url + '?folio=' + folio, this.authService.getAuthHeaders());
  }

  public getMovimientosObraByLiquidacion(idLiquidacion, page = null) {
    console.log('get service idLiquidacion', idLiquidacion);
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page + '&idLiquidacion=' + idLiquidacion, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true' + '&idLiquidacion=' + idLiquidacion, this.authService.getAuthHeaders());
  }

  activeSecurityModule(password) {
    const data = {password:password}
    return this.http.post(this.service_url + '/key', data, this.authService.getAuthHeaders());
  }

  public getFechaActual () {
    return this.http.get(this.service_url + '/fecha', this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(1, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public canSecurity() {
    return this.authService.canSecurity();
  }

  public exportCSV(idLiquidacion) {

    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.service_url + '/exportar?idLiquidacion=' + idLiquidacion, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateMovimientosObrasDate(date, dateMin, dateMax) {
    if (!this.validatorService.dateBetween(date, dateMin, dateMax)) {
      return this.errorService.betweenDate;
    }
  }

  public validateMovimientosObra(data) {
    console.log('validating... ', data);
    let error = [];

    // validacion de CUENTA
    if ($.isEmptyObject(data['cuentas_mixtas'])) {
      error['cuentas'] = this.errorService.required;
    }

    // validacion de FECHA INICIO
    const now = new Date().toISOString().slice(0, 10);
    if (!this.validatorService.required(data['fechaMovimiento']) || data['fechaMovimiento'] == '0000-00-00') {
      error['fechaMovimiento'] = this.errorService.required;
    } else if (!this.validatorService.date(data['fechaMovimiento'])) {
      error['fechaMovimiento'] = this.errorService.generic;
    }

    // validacion de CONCEPTO
    if (!this.validatorService.required(data['conceptos'].idConceptos)) {
      error['conceptos'] = this.errorService.required;
    }

    // validacion de DESCRIPCION
    if (this.validatorService.required(data['descripcion']) && !this.validatorService.max(data['descripcion'], 200)) {
      error['descripcion'] = this.errorService.max(200);
    }

    // validacion de IMPORTE
    if (!this.validatorService.required(data['importe'])) {
      error['importe'] = this.errorService.required;
    }

    // validacion de TRASPASO
    if (data['conceptos'].traspaso == 1) {

      // validacion de CUENTA DESTINO
      if ($.isEmptyObject(data['cuenta_destino'])) {
        error["cuenta_destino"] = this.errorService.required;
      }
      else if (data['cuenta_destino'].idCuentas == data['cuentas_mixtas'].idCuentas) {
        error["cuenta_destino"] = 'La cuenta destino debe ser diferente a la cuenta origen.';
      }

    }

    // validacion de EGRESO Y Traspaso
    if (data['tipoMovimiento'] != 2) {


      // validacion de Numero cheque
      if (data["numero"] !== "") 
        if ( !this.validatorService.numeric(data['numero'])) {
          error['numero'] = this.errorService.numeric;
        } else if (!this.validatorService.max(data['numero'], 20)) {
          error["numero"] = this.errorService.max(20);
        }

      // validacion de CFDI
      if (this.validatorService.required(data['cfdi']) && !this.validatorService.max(data['cfdi'], 200)) {
        error["cfdi"] = this.errorService.max(200);
      }

      }

      //validacion ingreso y egreso
      if(data['conceptos'].traspaso != 1){
        // validacion de PROVEEDORES
        if ($.isEmptyObject(data['proveedores'])) {
          error['proveedores'] = this.errorService.required;
        }
      }

    console.log('validating errors... ', error);

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/liquidacion-captura-movimientos-obra.service.ts